import MainLayout from "@/components/layout/MainLayout.vue";
import Pagination from 'laravel-vue-pagination';
import moment from 'moment';
import axios from "axios";
import { mapGetters } from "vuex";
import { ConvertNumService } from '@/assets/js/convertNumberService.js';
import AdvancedLaravelVuePaginate from 'advanced-laravel-vue-paginate';
import 'advanced-laravel-vue-paginate/dist/advanced-laravel-vue-paginate.css';
import { fetchNotificationCount } from "@/services/common/notification-service";

const convertNumberService = new ConvertNumService();

export default {
    name: "manageStudent",

    components: {
        MainLayout,
        Pagination,
        AdvancedLaravelVuePaginate
    },

    data() {
        return {
            keyword: "",
            students: {},
            pg_status: false,
            lastPage: "",
            currentPage: ""
        };
    },

    computed: {
        ...mapGetters(["schoolId", "teacherId", "studentId", "userType"]),
    },
    
    methods: {
        search(page = 1) {
            axios.get("/my/student/filter?page=" + page, {
                    params: {
                        keyword: this.keyword
                    }
                })
                .then((response) => {
                    this.pg_status = true;
                    this.students = response.data;
                    this.students.total = convertNumberService.convertEng2Mm(this.students.total);
                    this.lastPage = convertNumberService.convertEng2Mm(this.students.last_page);
                    this.currentPage = convertNumberService.convertEng2Mm(this.students.current_page);
                })
                .catch((error) => {
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('/');
                    }
                    console.log("Student Search API Error", error);
                });
        },
        
        getClassStudentList(page = 1) {
            // axios.get("/teacher/studentlist/" + this.teacherId + "?page=" + page)
            axios.get("/my/student/list?page=" + page)
                .then((response) => {
                    this.students = response.data;
                    this.students.total = convertNumberService.convertEng2Mm(this.students.total);
                    this.lastPage = convertNumberService.convertEng2Mm(this.students.last_page);
                    this.currentPage = convertNumberService.convertEng2Mm(this.students.current_page);
                })
                .catch((error) => {
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('/');
                    }
                    console.log("Manage Student API Error", error);
                });
        },
        
        approveStudent(classId, studentId) {
            axios.get("/my/class/" + classId + "/student/" + studentId + "/accept")
            // axios.get("/teacher/changestatus/approve/" + classStudentId + "/" + this.teacherId + "/" + studentId)
                .then(() => {
                    location.reload();
                })
                .catch((error) => {
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('/');
                    }
                    console.log("Approve Student API Error", error);
                });
        },

        customFormatter(date) {
            return moment(date).format('HH:mm');
        },

        cancelStudent(classId, studentId) {
            axios.get("/my/class/" + classId + "/student/" + studentId + "/reject")
            // axios.get("/teacher/changestatus/cancel/" + classStudentId + "/" + this.teacherId + "/" + studentId)
                .then(() => {
                    location.reload();
                })
                .catch((error) => {
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('/');
                    }
                    console.log("Cancel Student API Error", error);
                });
        },
    },

    mounted() {
        this.getClassStudentList();
        fetchNotificationCount();
    }
};
